import React, { memo, useCallback, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { FillerRow, Table } from '../Table/Table.tsx';
import styles from './StickyRowTable.module.scss';
import clsx from 'clsx';
function StickyRowTableComponent(props) {
    const { data, columns, stickyRow, getRowProps, ...restTableProps } = props;
    const headRef = useRef(null);
    const hasMeasuredHeaderRef = useRef(false);
    const [headerHeight, setHeaderHeight] = useState(0);
    useLayoutEffect(()=>{
        if (hasMeasuredHeaderRef.current || data.length == 0) return;
        if (headRef.current == null) return;
        setHeaderHeight(headRef.current.getBoundingClientRect().height);
        hasMeasuredHeaderRef.current = true;
    }, [
        data.length
    ]);
    const hasNoTableData = data.length == 0;
    const hasStickyRow = stickyRow != undefined;
    const stickyRowInData = hasStickyRow && stickyRow.index < data.length;
    const shouldAppendStickyRowToBottom = hasStickyRow && !stickyRowInData;
    const shouldShowEmptyText = shouldAppendStickyRowToBottom && hasNoTableData;
    const fillRemainingHeight = shouldAppendStickyRowToBottom ? 'none' : 'afterRows';
    const tableData = useMemo(()=>{
        if (shouldAppendStickyRowToBottom) return [
            ...data,
            stickyRow.data
        ];
        return data;
    }, [
        data,
        stickyRow,
        shouldAppendStickyRowToBottom
    ]);
    const stickyIndex = hasStickyRow ? stickyRowInData ? stickyRow.index : tableData.length - 1 : -1;
    const getStickyRowProps = useCallback((row, index)=>{
        const extraRowProps = getRowProps === null || getRowProps === void 0 ? void 0 : getRowProps(row, index);
        if (index != stickyIndex) return extraRowProps;
        return {
            ...extraRowProps,
            prefixComponent: shouldAppendStickyRowToBottom ? /*#__PURE__*/ React.createElement(FillerRow, {
                colSpan: columns.length
            }) : extraRowProps === null || extraRowProps === void 0 ? void 0 : extraRowProps.prefixComponent,
            style: {
                '--sticky-row-top': `${headerHeight}px`,
                ...extraRowProps === null || extraRowProps === void 0 ? void 0 : extraRowProps.style
            },
            className: clsx(styles.stickyRow, extraRowProps === null || extraRowProps === void 0 ? void 0 : extraRowProps.className)
        };
    }, [
        stickyIndex,
        headerHeight,
        getRowProps,
        shouldAppendStickyRowToBottom,
        columns.length
    ]);
    return /*#__PURE__*/ React.createElement(Table, {
        ...restTableProps,
        columns: columns,
        data: tableData,
        getRowProps: getStickyRowProps,
        headRef: headRef,
        fillRemainingHeight: fillRemainingHeight,
        showEmptyText: shouldShowEmptyText
    });
}
export const StickyRowTable = /*#__PURE__*/ memo(StickyRowTableComponent);
